
// en.js
export default {
  home: {
    tab1: 'Home',
    tab2: 'services',
    tab3: 'pricing',
    lang: '中文',
    lang1: '中',
    login: 'Log In',
    signup: 'Sign Up',
    banner1: 'To provide you with the ',
    banner2: 'most professional',
    banner3: '',
    banner4: 'Data acquisition solutions',
    bannerBtn: 'Enter dashboard',
    bannerTitle1: 'Professional global residential proxy',
    bannerSubtitle1: 'More than ',
    bannerSubtitle1_1: '60,000,000+',
    bannerSubtitle1_2: 'IPS',
    bannerTitle2: 'Precise positioning of major cities around the world',
    bannerSubtitle2: 'Meet ',
    bannerSubtitle2_1: 'crawler, e-commerce',
    bannerSubtitle2_2: ' and other business needs',
    bannerTitle3: 'Dynamic and static switch at will',
    bannerSubtitle3: 'Support ',
    bannerSubtitle3_1: 'http,https,socks5',
    bannerSubtitle3_2: ' easy to use',
    sTitle: 'Provide reliable data acquisition solutions for your business',
    sTitle1: 'Residential proxy',
    sSubtitle1: 'Reality-like fetching mode without IP',
    sSubtitle1_1: 'blocking',
    st1_1: 'High success rate',
    st1_2: 'City-level orientation',
    st1_3: '24/7 support',
    sTitle2: 'Leading technology',
    sSubtitle2: 'AI and ML based solutions for effective information capture',
    st2_1: 'No bandwidth or browsing restrictions',
    st2_2: 'Compatible with various browsers and tools',
    st2_3: 'High performance proxy architecture',
    sTitle3: 'Real-time crawler',
    sSubtitle3: 'Extract data from search engines and e-commerce sites',
    st3_1: '100% delivery',
    st3_2: 'Country/region and ASN filtering',
    st3_3: 'Adaptive parser',
    gTitle: 'MIYAIP services in more than 200 countries around the world',
    gName1: 'Asia',
    gCountries1: '48 countries',
    gName2: 'European',
    gCountries2: '44 countries',
    gName3: 'African',
    gCountries3: '54 countries',
    gName4: 'Australasia',
    gCountries4: '16 countries',
    gName5: 'North America',
    gCountries5: '23 countries',
    gName6: 'South America',
    gCountries6: '12 countries',
    pTitle: 'More Preferential Price',
    pTitle1: 'Dynamic Residence',
    pSubtitile1: 'positioning ',
    pSubtitile1_1: 'the country',
    pDescribe1: 'Charge by data, Unlimited IP number',
    pType1: 'Data',
    pUnit1: '/G',
    pSubtitile2: 'positioning ',
    pSubtitile2_1: 'the city',    
    pTitle3: 'Static residence',
    pSubtitile3: '1 IP/month',
    pSubtitile3_1: '/exclusive',
    pDescribe3: 'Unlimited data, Charge by IP number',
    pType3: 'IP',
    pUnit3: '/IP',    
    pSubtitile4: '1 IP/month',
    pSubtitile4_1: '/share 2 users',
    pBtnBuy: 'Buy now',
    pPayType: 'We accept',
    pContact: 'Please call us for more special packages',
    pBtn: 'Free trial',
    cTitle: 'The reason why we were chosen',
    cSubtitle: 'More than 500 countries and regions of the IP, faster speed, the best server, to give you better service',
    cs1: 'Faster speed',
    cs2: 'More stable service',
    cs3: 'Exclusive agency',
    cs4: 'Fast integration',
    goBtn: 'Go to Get Solutions',
    lTel: 'tel',
    lEmail: 'support email',
    lTime: 'support online time',
    lAddress: 'office address',
    lPolicy: 'Policy',
    lmiyaPolicy: 'Miya Customer Policy',
    lLink: 'Friendship link',
    lTip: `MIYAIP only provides IP services for formal commercial purposes, and any actions taken by users using MIYAIP do not represent MIYAIP's intentions or views. It is strictly prohibited for users to engage in any illegal or criminal activities using MIYAIP. This product does not provide wall climbing services, and any related responsibilities arising from this are borne by the user. MIYAIP does not assume any legal responsibility for this.`,
    lRights: 'BARNETWORK INC © 2023 All Rights Reserved',
    noData: 'No Data',
    WeChat: 'WeChat',
    Telegram: 'Telegram',
  },
  menu: {
    m1: 'Dashboard',
    m2: 'Dynamic Residence',
    m2_1: 'Proxy Generation - Country',
    m2_2: 'Proxy Generation - City',
    m2_3: 'Buy Traffic',
    m3: 'Static Residential',
    m3_1: 'Purchase Proxy',
    m3_2: 'Purchased Details',
    m4: 'Historical orders',
    m5: 'Help',
    m5_1: 'Help Documents',
    m5_2: 'Customer Policy',
    m6: 'Developer API',
    m7: 'Invite Reward',
    backHome: 'Back Homepage',
  },
  dashboard: {
    title1: 'Dashboard - Dynamic Residential Proxy',
    dataName1: 'Total traffic [Gb]',
    dataName2: 'Used traffic [Gb]',
    dataName3: 'Remaining traffic [Gb]',
    subtitle1: 'Traffic usage trend',
    subtitle2: 'Details of purchased static residences',
    title2: 'Dashboard - Static Residential Proxy',
    buyBtn: 'Buy Traffic',
    titleCountry: 'Positioning the country',
    titleCity: 'Positioning cities',
    proxyBtn: 'Proxy Generation',
    more: 'more',
    s5qr: 'Socks5 QR code',
    expirationTime: 'Expiration time',
    typeString: 'Type',
    total1: 'All Proxy',
    total2: 'Exclusive Proxy ',
    total3: 'Shared Proxy', 
    orders: 'orders',
  },
  login: {
    thank: 'Thanks for choosing Miya',
    title1: 'User Login',
    email: 'E-mail Address',
    password: 'Password',
    checkedText: 'By registering, you agree to the ',
    checkedText1: 'Terms of Service',
    login: 'Log in',
    noAccount: "Don't have an account? ",
    signup: 'Sign Up',
    forgetPassword: 'Forget Password',
    errorEmail: 'Please enter the correct email address',
    errorPassword: 'Please enter the password',
    title2: 'User Register',
    emailCode: 'CAPTCHA',
    sendCode: 'Send Code',
    codeTip: 'not receive number code, please check the mail bin',
    repeatPassword: 'Repeat Password',
    inviteCode: 'Invite Code',
    checkedText2: 'By registering, you agree to the Terms of Service ',
    account: 'Already have an account? ',
    title3: 'Reset Password',
    btnOK: 'Confirm',
    repeatPassword1: 'The two passwords entered do not match!',
    placeholder1: 'Please enter your email address',
    placeholder2: 'Please enter the verification code',
    placeholder3: 'Please enter ',
    placeholder4: 'Please enter the invitation code (can be filled in blank)',
    error1: 'Please read and agree to the service terms',
    error2: 'Please enter the invitation code (can be filled in blank)',
    editPassword: 'Change password',
    balance: 'Account balance',
    recharge: 'Recharge USDT',
    recharge1: 'Recharge',
    logout: 'Log out',
    success: 'Operation successful',
    rechargeType: 'Recharge Type',
    rechargeCode: 'Pay Address',
    hash: 'Transaction Hash',
    rechargeTip: 'USDT transactions require confirmation of time. Please wait for 10-20 minutes after transferring the funds and submit the order number for recharge',
    hashTip: 'Fill in the transaction serial number after recharging, and the website will display the USDT balance you recharged',
    rechargeInput: 'Please input hash',
    qrCodeText: 'Payment address QR code',
    errorLogin: 'Please log in to the system first',
    commit: 'Submit',
    balance1: 'USDT balance',
    agree: 'agree',
    close1: 'Click this area to close',
  },
  pCountry: {
    title1: 'Dynamic Residential Proxy Generation - Positioning Country',
    network: 'Proxy Network',
    country: 'Country',
    type: 'Pool type',
    time: 'IP fixed switchover time',
    generationType: 'Generation type',
    num: 'Number',
    networkTip: 'Proxy network prompt text',
    countryTip: '国家提示文字',
    typeTip: 'The IP effect varies slightly within different IP pools',
    timeTip: 'The cycle of automatic IP switching',
    generationTypeTip: '生成类型提示文字',
    numTip: '数量提示文字',
    selectPlaceholder: 'Please select',
    inputPlaceholder: 'Please enter',
    api: 'API toggle proxy button',
    apiText: 'click if necessary',
    apiTip: 'Suitable for customers who manually switch IP through API',
    copy: 'Copy',
    btnGeneration: 'Generating',
    exportApi: 'Api extraction',
    btnQrcode: 'Generate QR code',
    qrPlaceholder: 'Enter or paste proxy text to generate a QR code (only one proxy text can be converted into a QR code at a time)',
    emptyQr: 'No QR code currently available',
    qrcodeError: 'Proxy text formatting error',
    socks5Name: 'Generate socks5 QR code (can be directly scanned using Shadowrocket)',
  },
  pCity: {
    title1: 'Dynamic Residential Proxy Generation - Positioning Cities',
    countryCity: 'Country Generate Location City',
    countryCityTip: 'Select the IP address you need for the location',
    placeholderCountryCity: 'Please select Country Generate Location City',
    position: 'server location',
    positionTip: 'Choose the server region closest to your local network to experience faster proxy speeds',
    state: 'state',
    city: 'city',
    placeholderCity1: 'Please select a country',
    placeholderCity2: 'Please select a location',
    placeholderCity3: 'Please select a city',
  },
  pTraffic: {
    title1: 'Dynamic Residential - Purchase Traffic',
    name1: 'category',
    name2: 'unit-price',
    name3: 'duration',
    name4: 'IP POOL',
    name5: 'Dynamic IP Pool',
    name6: 'concurrency',
    name7: 'Time variability',
    name8: 'City positioning',
    name9: 'flow',
    option1: 'No expiration',
    option2: 'Exclusive IP Pool',
    option3: '2 super large IP pools with a total of over 60 million IPs',
    option4: 'Infinite concurrency',
    option5: 'Variable time effect',
    option6: 'Not Supported',
    option21: 'No expiration',
    option22: 'Exclusive IP Pool',
    option23: '2 super large IP pools with a total of over 60 million IPs',
    option24: 'Infinite concurrency',
    option25: 'Variable time effect',
    option26: 'support',
    max100: 'Max 100G data',
    btnLearn: 'Learn more',
    buyIt: 'Buy it',
    selectStr: 'Selected Location',
    pTraffic: 'Purchase traffic',
    discountCode: 'discount code',
    placeholderDc: 'Please enter the discount code',
    amount: 'Total amount',
    btnUsdt: 'USDT balance',
    otherPay: 'Other payment methods',
    contactTitle: 'Contact Us',
    Alipay: 'Alipay',
    WeChat: 'WeChat',
    payUSDT: 'USDT balance payment',
    payOk: 'Confirm Payment',
    payCancel: 'Cancel',
    payCode: ' Payment code',
    paid: 'have paid',
    selectType: 'Please select a category',
    discountCodeError: 'Discount Invalid',
    commingSoon: 'Contact customer service to activate',
    loading: 'The order is currently loading, please wait',
    noSelect: 'No traffic category selected',
    dollar: 'dollar',
  },
  pAgent: {
    title1: 'Static Residential - Purchase Proxy',
    country: 'Demand country',
    countryTip: '需求国家Tip',
    ipType: 'IP Authorization Type',
    ipTypeTip: '(Sharing type: 1 IP share 2 users)',
    price1: 'Exclusive unit price',
    price2: 'Shared unit price',
    priceUnit: '/IP/month',
    ipTime: 'IP purchase duration',
    ipTimeTip: 'IP购买时长Tip',
    day: 'days',
    year: 'year',
    ipNumber: 'Number of IP purchases',
    maxIPNum: '(Maximum quantity 100)',
    type1: 'Exclusive ',
    type2: 'share ',
    select: ' Selected ',
    title2: 'Static Residential - Purchased Details',
    all: 'whole',
    operation: 'operate',
    btnRenew: 'renew',
    btnDel: 'delete',
    unit: 'orders',
    mutRenew: 'renew',
    mutDel: 'delete',
    mutCancel: 'cancel',
    btnExport: 'export',
    htitl1: 'All [orders]',
    htitl2: 'Unpaid [order]',
    htitl3: 'Paid [order]',
    htype1: 'Unpaid',
    htype2: 'paid',
    htname1: 'Order ID',
    htname2: 'Order name',
    htname3: 'number',
    htname4: 'Status',
    htname5: 'order time',
    htname6: 'time of payment',
    renewIP: 'Number of IP renewals',
    renewTime: 'IP renewal duration',
    placeholderSearch: 'Please enter IP for query',
    placeholderSearch1: 'Please enter ID for query',
    deleteDialogTitle: 'Confirm deletion?',
    deleteDialogText: 'Unable to recover after deletion',
    t1:'OriginIP (Socks5)',
    t2:'OriginIP (http)',
    t3:'TransitProxy (Socks5)',
    t4:'TransitProxy (http)',
  },
  reward: {
    cardName: 'Rebate balance',
    tipText: ' Withdrawal at 20U ',
    btn1: 'Withdraw',
    btn2: 'All transferred to USDT balance',
    title2: 'Invitation Function',
    subtitle2: 'When you invite friends to register',
    text1: 'ou will receive ',
    text2: 'each time ',
    text3: 'the recharge amount as a',
    text4: '10% ',
    text5: 'rebate, which can be used for withdrawal or direct purchase of products',
    copyBtn1: 'Copy invitation code',
    copyBtn2: 'Copy invitation link',
    placeholder2: 'Invitation Link',
    text6: 'If you use the invitation link of another account owned by you during registration, we have the right to suspend both the inviting account and the purchasing account (no possibility of being unblocked)',
    title3: 'Rebate Records',
    text7: 'Rebate records brought by invited users',
    tTitle1: 'ID',
    tTitle2: 'Invited user',
    tTitle3: 'Obtaining Rebates',
    tTitle4: 'Acquisition Time',
    copySuccess: 'Replicating Success',
    copyError: 'copy failed',
  },
  tos: {
    t1: "Privacy Policy",
    c11: "At MiyaIP, we are in the business of data and it's precisely because of this that we take data privacy so seriously. Our customers entrust us to empower their businesses with clean, compliant, and ethically sourced data whilst retaining the highest standards of privacy. Our products and services operate on a global scale and as such we continuously monitor the dynamic global privacy landscape and adapt accordingly to ensure complete compliance with privacy laws.",
    c12: "This Privacy Policy addresses both users who actively choose to use our services, as described below and also to individuals whose personal data we may process as part of our operation.Please feel free to read on for a detailed breakdown of our privacy policy or contact us with any questions regarding our policy or data legislation compliance.",
    c13: `MiyaIP ("MiyaIP", "we", or "us") is the owner of the website miyaip.com/ ("the Site")and any accompanying services, features, content, and applications offered by us (collectively referred herein as "the Services"). We are concerned about your privacy and have designed this Privacy Policy in order to help you decide whether to use the Services and to provide all required information about our privacy practices. If applicable to you, by accessing and using the Services, or providing information to us in other formats, you agree and accept the terms of this Privacy Policy as amended from time to time and consent to the collection and use of information in the manner set out in this Privacy Policy. We encourage you to review this Privacy Policy carefully and to periodically refer to it so that you understand it and any subsequent changes made to it. `,
    t2: `What types of information do we collect?`,
    c21: `We collect the following types of data from you when you use the Services:`,
    c22: `(i) Anonymous Information: We collect Anonymous Information about your use of the Services for three reasons: first, to allow us to provide the Services and constantly improve them; second, for security reasons; and third, so that we can audit and track usage statistically, audit our affiliates, and calculate payments to 3rd parties. Such Anonymous Information includes your approximate geo-location, hardware specifications, OS version, browser type and version, the date of the Software installation, your URL requests, and respective time stamps. Anonymous data may also include any other data that is not sensitive and does not identify or may identify you.`,
    c23: `(ii) Personal Information: Personal Information is information that may be of a private or sensitive nature, and which identifies or may identify you. The Personal Information we collect and retain may include your IP address, Hostname, your name, email address in the case that you provide us with this information (for instance when you open an account or if you approach us through the "contact us" option), screen name, payment and billing information (if you purchase premium services) or other information we may ask from time to time as will be required for the Services provisioning. `,
    t3: `Legal basis for processing`,
    c31: `Processing User Data is necessary for the performance of our contractual obligations towards you and providing you with our services, to protect our legitimate interests and to comply with our legal obligations.`,
    c32: `Processing of Public Data is done in accordance with our legitimate interest, as long as such interest does not override your fundamental rights and freedom.`,
    t4: `How do we use your information?`,
    c41: `We use User Data in order to provide you with the Service and to comply with our legal requirements and internal guidelines. This means that we will use the information to set up your account, provide you with support regarding the Service, communicate with you for updates, marketing offers or concerns you may have and conduct statistical and analytical research to improve the Service. We may use Public Data in order to provide our users with our Services.`,
    t5: `Information we share`,
    c51: `We do not share your Personal Information with third parties except with your specific consent pursuant to this Privacy Policy or if required by applicable laws or court order.`,
    c52: `We may also share your Personal Information and other information in special cases if we have a good reason to believe that it is necessary to:`,
    c53: `(i) comply with law, regulation, subpoena or court order;`,
    c54: `(ii) detect, prevent or otherwise address fraud, security, violation of our policies or technical issues;`,
    c55: `(iii) enforce the provisions of this Privacy Policy or any other agreements between you and us, including investigation of potential violations thereof;`,
    c56: `(iv) protect against harm to the rights, property or safety of us, its partners, its affiliates, users, or the public.`,
    t6: `Security and Confidentiality`,
    c61: `We use industry-standard information, security tools, and measures, as well as internal procedures and strict guidelines to prevent information misuse and data leakage. Our employees and contractors access the information on a need-to-know basis and subject to confidentiality obligations.`,
    c62: `We use measures and procedures that substantially reduce the risks of data misuse, but we cannot guarantee that our systems will be absolutely safe. If you become aware of any potential data breach or security vulnerability, you are requested to contact us immediately. We will use all measures to investigate the incident, including preventive measures, as required.`,
    t7: `Your Choices and Rights`,
    c71: `We value your privacy and your control of personal information. You may therefore notify us that you wish to review your Personal Information or delete it. You can notify us by sending an email to admin@miyaip.com. You may choose at any time not to allow us or any third party to collect data about you. You may request to view or edit Personal Information that is stored about you.`,
    c72: `If you are a resident of California, United States, or of the European Union, you have the right to send us a written request regarding a list of Personal Information categories that we may have disclosed to third parties or to which we may have given to third parties, and the details of such third parties. To exercise such right, you may contact us at: admin@miyaip.com`,
    t8: `Information Warranty Disclaimer`,
    c81: `Notwithstanding anything else in this Policy, we are not responsible for the accuracy, correctness, and security of any of the information we gather, store, and disclose to you or to anyone else.`,
    t9: `Contact Us`,
    c91: `If you feel that your privacy was not treated in accordance with our Privacy Policy, or if you believe that your privacy has been compromised by any person in the course of using the Services, please contact us at: admin@miyaip.com and our privacy officer shall promptly investigate.`,
    t_1: `Introduction`,
    c_11: `These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, MIYAIP accessible at www.miyaip.com.`,
    c_12: `These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.`,
    c_13: `MIYAIP does not knowingly collect, either online or offline, personal information from persons under the age of thirteen. If you are under 18, you may use www.miyaip.com only with the permission of a parent or guardian.`,
    t_2: `Refund Policy`,
    c_21: `These proxies are active from the time you receive them. All proxies are tested before delivery and are fully working when delivered. Proxies are designated as data center or residential based on the product name and description, and are not decided by the customer. We are not responsible for bans during release for improper use and having an incorrect setup. We reserve the right to deactivate proxies with excessive bandwidth usage or usage outside of its intended purposes such as video streaming, or file sharing. Please do only use our proxies on the websites that pertain to the purpose of the product. By purchasing this item, you are agreeing to our TOS "No Returns" policy due to the nature of the product. All products sold on www.miyaip.com are virtual and cannot be returned.`,
    t_3: `Acceptable Use Policy`,
    c_31: `You are prohibited from using the site, its content and services:  `,
    c_32: `(a) for any unlawful purpose; `,
    c_33: `(b) to solicit others to perform or participate in any unlawful acts;`,
    c_34: `(c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances;`,
    c_35: `(d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; `,
    c_36: `(e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability;`,
    c_37: `(f) to submit false or misleading information;`,
    c_38: `(g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; `,
    c_39: `(h) to collect or track the personal information of others; `,
    c_310: `(i) to spam, phish, pharm, pretext, spider, crawl, or scrape;`,
    c_311: `(j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses without prior notice.`,
    t_4: `Intellectual Property Rights`,
    c_41: `Other than the content you own, under these Terms, MIYAIP and/or its licensors own all the intellectual property rights and materials contained in this Website.`,
    c_42: `You are granted limited license only for purposes of viewing the material contained on this Website.`,
    c_43: `Restrictions`,
    c_44: `You are specifically restricted from all of the following:`,
    c_45: `publishing any www.miyaip.com material in any other media;`,
    c_46: `selling, sublicensing and/or otherwise commercializing any Website material;`,
    c_47: `publicly performing and/or showing any Website material;`,
    c_48: `using this www.miyaip.com in any way that is or may be damaging to this Website;`,
    c_49: `using this www.miyaip.com in any way that impacts user access to this Website;`,
    c_410: `using this www.miyaip.com contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;`,
    c_411: `engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;`,
    c_412: `using this Website to engage in any advertising or marketing.`,
    c_413: `Certain areas of this Website are restricted from being access by you and MIYAIP may further restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.`,
    t_5: `No Warranties`,
    c_51: `This Website is provided “as is,” with all faults, and MIYAIP express no representations or warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing contained on this Website shall be interpreted as advising you.`,
    t_6: `Limitation of liability`,
    c_61: `In no event shall MIYAIP, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. MIYAIP including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.`,
    t_7: `Indemnification`,
    c_71: `You hereby indemnify to the fullest extent MIYAIP from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.`,
    t_8: `Severabillity`,
    c_81: `If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.`,
    t_9: `Variation of Terms`,
    c_91: `MIYAIP is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.`,
    t_10: `Assignment`,
    c_101: `MIYAIP is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.`,
    t_11: `Entire Agreement`,
    c_11_1: `These Terms constitute the entire agreement between MIYAIP and you in relation to your use of this Website, and supersede all prior agreements and understandings.`,
    t_12: `Governing Law & Jurisdiction`,
    c_121: `miyaip.com is a website of BARNETWORK INC, and these terms will be governed by and interpreted in accordance with the laws of the United States.`,
    t_21: `Right to refuse service`,
    c_211: `We reserve the right to refuse to sell our products or services to any person or entity who, in our sole discretion, is deemed not suitable under our safety procedures and policies`,
    t_22: `Illegal uses are prohibited`,
    c_221: `All illegal activities that would involve MiyaIP’ products and solutions are prohibited`,
    t_23: `Customer compliance assessments`,
    c_231: `If necessary, MiyaIP risk and compliance teams will perform an assessment of the customer and their use case`,
    t_24: `Some ports are blocked by default`,
    c_241: `Certain ports are blocked by default to prevent illegal activities`,
    t_25: `Only 75% of customers are approved`,
    c_251: `Each year at least quarter of all customer enquires are rejected due to not conforming to our policies and standards`,
  }
}